export default "__VITE_ASSET__B8K3cgmM__"